import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { PButtonModule } from '@panaya/ui/p-button';
import { PFieldModule } from '../p-field';
import { PPaginatorComponent } from './p-paginator.component';
import { NgForOf, NgIf } from '@angular/common';

@NgModule({
    declarations: [PPaginatorComponent],
    imports: [PButtonModule, PFieldModule, TranslateModule, NgIf, NgForOf],
    exports: [PPaginatorComponent]
})
export class PPaginatorModule {}
